import React from 'react';
import DynamicIcon from '../DynamicIcon';

/**
 * Componente per visualizzare stato vuoto nella DataTable
 * 
 * @param {Object} props
 * @param {String} props.message - Messaggio da mostrare
 * @param {String} props.iconClass - Classe dell'icona (FontAwesome)
 */
const EmptyState = ({
    message = 'Nessun dato disponibile',
    iconClass = 'fa-solid fa-table'
}) => {
    return (
        <div className="data-table-empty-state">
            <DynamicIcon iconClass={iconClass} />
            <p className="mt-2">{message}</p>
        </div>
    );
};

export default EmptyState;
